import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./RecentProjects.css";
import axios from "axios";

const RecentProjects = () => {
  const [slides, setSlides] = useState(1);
  const [mounted, setMounted] = useState(false);
  const [projects, setProjects] = useState([]);

  const API_URL = "https://admin.cmgroupofcompanies.com";

  /* ===== RESPONSIVE SLIDES ===== */
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 768) setSlides(1);
      else if (width <= 1024) setSlides(3);
      else setSlides(3);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    setMounted(true);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ===== FETCH PROJECTS FROM DB ===== */
useEffect(() => {
  const fetchImages = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/api/events-images.php`
      );
      setProjects(res.data); // 🔥 all images
    } catch (error) {
      console.error("Error fetching team images:", error);
    }
  };

  fetchImages();
}, []);


  if (!mounted) return null;

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: slides,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dotsClass: "rp-dots",
    customPaging: () => <button className="cm-dot"></button>,
  };

  return (
    <div className="rp-section-bg">
      <section className="rp-section">

        {/* ================= TOP CONTENT ================= */}
        <div className="rp-top">
          <div className="rp-top-left">
            <h5 className="rp-small-title">OUR SUCCESSFUL PROJECT</h5>
            <h2 className="rp-main-title">Recent Projects</h2>
          </div>

          <div className="rp-top-right">
            <p>
              We strive to deliver real-world solutions tailored to small and
              large-scale projects, supporting long-term sustainability,
              innovation, and measurable success.
            </p>
          </div>
        </div>

        {/* ================= SLIDER ================= */}
        <div className="rp-slider-wrapper">
          <Slider {...settings}>
            {projects.map((item, index) => (
  <div key={index} className="rp-slide-item">
    <img
      src={item.image}
      alt="Team"
      className="rp-project-image"
    />
  </div>
))}
          </Slider>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="rp-footer-banner">
          <span className="rp-free-tag">FREE</span>
          <p>
            Let’s build something great together.{" "}
            <a href="/contact" className="rp-link">Get free quote</a>
          </p>
        </div>

      </section>
    </div>
  );
};

export default RecentProjects;
